/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import AnswerResult from '../animations/answer-result';
import Crocodile from '../animations/crocodile';
import Bird from '../animations/bird';
import Frog from '../animations/frog';
import Dragonfly from '../animations/dragonfly';
import Stars from '../ui/stars';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

/**
 *
 */
EDC.Games.BiggerThan.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.BiggerThan, 3]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.BiggerThan.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.bubbles = {
    first: {
      x: 310,
      y: 457,
      sprite: null,
      value: null,
    },
    second: {
      x: 1610,
      y: 457,
      sprite: null,
      value: null,
    },
  };
  this.currentPairIndex = 0;
  this.correctAnswer = null;
  this.stars = null;
  this.answerResult = null;
  this.crocodile = null;
  this.frogs = null;
  this.dragonfly = null;
  this.bird = null;
};
/**
 *
 */
EDC.Games.BiggerThan.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.BiggerThan.Scenes.Main.prototype.constructor = EDC.Games.BiggerThan.Scenes.Main;

EDC.Games.BiggerThan.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadPair();

  this.createBasicUI();
};

EDC.Games.BiggerThan.Scenes.Main.prototype.createTemplateUI = function () {
  this.add.sprite(this.game.config.width / 2, 1030, 'title');

  this.createBubbles();

  this.crocodile = new Crocodile(this);
  this.crocodile.create();

  this.frogs = new Frog(this);
  this.frogs.createFrog(0, 700, false);
  this.frogs.createFrog(1880, 600, true);
  this.frogs.start();

  this.dragonfly = new Dragonfly(this);
  this.dragonfly.create();

  this.bird = new Bird(this);
  this.bird.create();
  this.bird.start();

  this.stars = new Stars(10, 10, this, this.gameConfig.sets[this.difficulty].iterations[this.iteration].pairs.length);
  this.stars.create();

  this.answerResult = new AnswerResult(this).create();
};

EDC.Games.BiggerThan.Scenes.Main.prototype.createBubbles = function () {
  Object.entries(this.bubbles).forEach(([key]) => {
    const container = this.add.container(this.bubbles[key].x, this.bubbles[key].y);
    const sprite = this.add.sprite(0, 0, 'number-bubble');
    sprite.setScale(1.2);
    container.setData('name', key);
    container.add(sprite);
    const label = this.add
      .text(0, 0, '-1', {
        fontFamily: 'Arial', fill: 'black', fontSize: '110px', fontStyle: 'bold',
      })
      .setOrigin(0.5);
    container.add(label);
    const bounds = container.getBounds();
    container.setSize(bounds.width, bounds.height);
    container.setInteractive();
    container.on('pointerup', this.animateBubbleClick.bind(this, container), this);
    this.cursorManager.setDefaultDraggableEvents(container);
    this.bubbles[key].sprite = container;
  });
};
/**
 *
 */
EDC.Games.BiggerThan.Scenes.Main.prototype.animateBubbleClick = function (bubble) {
  this.tweens.add({
    targets: bubble,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 100,
    ease: 'Linear',
    yoyo: true,
    onComplete: this.onBubbleUp.bind(this, bubble),
  });
};
/**
 *
 */
EDC.Games.BiggerThan.Scenes.Main.prototype.onBubbleUp = function (bubble) {
  if (this.answerResult.isRunning) return;
  if (this.currentPairIndex >= this.gameConfig.sets[this.difficulty].iterations[this.iteration].pairs.length) return;

  const name = bubble.getData('name');
  if (this.bubbles[name].value === this.correctAnswer) {
    this.playCorrect();
    this.stars.setCorrect(this.currentPairIndex);
    this.answerResult.show(
      true,
      name === 'first' ? this.bubbles.first.value : this.bubbles.second.value,
      name === 'first' ? this.bubbles.second.value : this.bubbles.first.value,
      this.loadNextPair.bind(this),
    );
  } else {
    this.stars.setWrong(this.currentPairIndex);
    this.answerResult.show(
      false,
      name === 'first' ? this.bubbles.second.value : this.bubbles.first.value,
      name === 'first' ? this.bubbles.first.value : this.bubbles.second.value,
      this.loadNextPair.bind(this),
    );
    this.crocodile.fallDown();
    this.playWrong();
  }
  if (this.currentPairIndex < this.gameConfig.sets[this.difficulty].iterations[this.iteration].pairs.length) {
    this.currentPairIndex = this.currentPairIndex + 1;
  }
};
/**
 *
 */
EDC.Games.BiggerThan.Scenes.Main.prototype.loadNextPair = function () {
  this.crocodile.backToLog();
  if (this.currentPairIndex >= this.gameConfig.sets[this.difficulty].iterations[this.iteration].pairs.length) {
    this.showSummary();
  } else {
    this.loadPair();
  }
};

EDC.Games.BiggerThan.Scenes.Main.prototype.loadPair = function () {
  const pair = this.gameConfig.sets[this.difficulty].iterations[this.iteration].pairs[this.currentPairIndex];
  this.bubbles.first.value = pair[0];
  this.bubbles.first.sprite.getAt(1).setText(pair[0]);
  this.bubbles.second.value = pair[1];
  this.bubbles.second.sprite.getAt(1).setText(pair[1]);
  this.correctAnswer = pair[0] > pair[1] ? pair[0] : pair[1];
};

export default EDC.Games.BiggerThan.Scenes.Main;
